import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 
  
  .generated-images-holder-var5 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var5 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .text-var5 {
    position: absolute;
    width: 100%;
    padding: 0 20px;
    bottom: 30px;
    font-size: 45px;
    line-height: 1.2;
    text-align: center;
    color: #000;
    font-weight: 400;
    font-family: CustomArial;
    letter-spacing: -0.05px;
    &--top {
      bottom: auto;
      top: 30px;
    }
    p {
      background-color: white;
      display: inline-block;
      margin: 0;
      padding: 14px 39px 16px;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
  }
  .full-image-var5 {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
  .actual-photo-var5 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
    &--top {
      top: 0;
      bottom: auto;
    }
  }
`;

export default VariationsStyles;
